import { createAsyncThunk } from "@reduxjs/toolkit";
import { addWidgetApi } from "../apis";
import { showSnackbar } from "../slices/SnackbarSlice";
import {
  copyWidgetApi,
  deleteWidgetApi,
  editWidgetApi,
  editMapWidgetApi,
  getWidgetApi,
  getWidgetDataApi,
  getWidgetPinsApi,
  getWidgetListApi,
  getWidgetDetailApi,
  getWidgetLocalitiesApi,
  setwidgetpreferenceApi,
  sendWidgetInstallEmailApi,
} from "../apis/WidgetApi";

export const addWidgetAction = createAsyncThunk(
  "add/widget",
  async (
    payload: any,
    { rejectWithValue, dispatch }
  ) => {
    try {
      const response = await addWidgetApi(payload);
      dispatch(
        showSnackbar({ message: response?.data?.message, type: "success" })
      );
      return response.data;
    } catch (error: any) {
      dispatch(
        showSnackbar({ message: error?.response?.data?.message, type: "error" })
      );
      return rejectWithValue(error?.message || "Failed to add widget");
    }
  }
);

export const editWidgetAction = createAsyncThunk(
  "edit/widget",
  async (payload: any, { rejectWithValue, dispatch }) => {
    try {
      const response = await editWidgetApi(payload);
      dispatch(
        showSnackbar({ message: response?.data?.message, type: "success" })
      );
      return response.data;
    } catch (error: any) {
      dispatch(
        showSnackbar({ message: error?.response?.data?.message, type: "error" })
      );
      return rejectWithValue(error?.message || "Failed to add widget");
    }
  }
);

// export const getWidgetAction = createAsyncThunk(
//   "get/widget",
//   async (_, { rejectWithValue }) => {
//     try {
//       const response = await getWidgetApi();
//       return response.data;
//     } catch (error: any) {
//       return rejectWithValue(error?.message || "Failed to get widget");
//     }
//   }
// );

export const getWidgetAction = createAsyncThunk(
  "get/widget",
  async (business_id: string, { rejectWithValue }) => {
    try {
      const response = await getWidgetApi(business_id);
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error?.message || "Failed to get widget");
    }
  }
);

export const copyWidgetAction = createAsyncThunk(
  "copy/widget",
  async (widget_id: string, { rejectWithValue, dispatch }) => {
    try {
      const response = await copyWidgetApi(widget_id);
      dispatch(
        showSnackbar({ message: response?.data?.message, type: "success" })
      );
      return response.data;
    } catch (error: any) {
      dispatch(
        showSnackbar({ message: error?.response?.data?.message, type: "error" })
      );
      return rejectWithValue(error?.message || "Failed to delete widget");
    }
  }
);
export const deleteWidgetAction = createAsyncThunk(
  "delete/widget",
  async (widget_id: string, { rejectWithValue, dispatch }) => {
    try {
      const response = await deleteWidgetApi(widget_id);
      dispatch(
        showSnackbar({ message: response?.data?.message, type: "success" })
      );
      return response.data;
    } catch (error: any) {
      dispatch(
        showSnackbar({ message: error?.response?.data?.message, type: "error" })
      );
      return rejectWithValue(error?.message || "Failed to delete widget");
    }
  }
);

export const getWidgetDataAction = createAsyncThunk(
  "get/widgetData",
  async (
    payload: { business_id: string; widget_id?: string },
    { rejectWithValue }
  ) => {
    try {
      const response = await getWidgetDataApi(payload);
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error?.message || "Failed to get widget data");
    }
  }
);

export const getWidgetPinsAction = createAsyncThunk(
  "get/widgetPins",
  async (
    payload: {
      business_id: string;
      widget_id: string;
      bbox?: { sw: [number, number]; ne: [number, number] };
      zoom?: number;
      is_filter_by_category?: boolean;
      selected_category?: string[];
      is_filter_by_locality?: boolean;
      selected_localities?: string[];
    },
    { rejectWithValue }
  ) => {
    try {
      const response = await getWidgetPinsApi(payload);
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error?.message || "Failed to get widget pins");
    }
  }
);

export const getWidgetListAction = createAsyncThunk(
  "get/widgetList",
  async (
    payload: {
      business_id: string;
      widget_id: string;
      cursor?: string;
      limit?: number;
      is_filter_by_category?: boolean;
      selected_category?: string[];
      is_filter_by_locality?: boolean;
      selected_localities?: string[];
      [key: string]: any;
    },
    { rejectWithValue }
  ) => {
    try {
      const response = await getWidgetListApi(payload);
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error?.message || "Failed to get widget list");
    }
  }
);

export const getWidgetLocalitiesAction = createAsyncThunk(
  "get/widgetLocalities",
  async (
    payload: {
      business_id: string;
      widget_id?: string;
      is_filter_by_category?: boolean;
      selected_category?: string[];
    },
    { rejectWithValue }
  ) => {
    try {
      const response = await getWidgetLocalitiesApi(payload);
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error?.message || "Failed to get widget localities");
    }
  }
);

export const editMapWidgetAction = createAsyncThunk(
  "edit/mapWidget",
  async (payload: any, { rejectWithValue, dispatch }) => {
    try {
      const response = await editMapWidgetApi(payload);
      dispatch(
        showSnackbar({ message: response?.data?.message, type: "success" })
      );
      return response.data;
    } catch (error: any) {
      dispatch(
        showSnackbar({ message: error?.response?.data?.message, type: "error" })
      );
      return rejectWithValue(error?.message || "Failed to edit map widget");
    }
  }
);

export const getMomentDetailAction = createAsyncThunk(
  "get/momentDetail",
  async (
    payload: { business_id: string; widget_id: string; post_id: string },
    { rejectWithValue }
  ) => {
    try {
      const response = await getWidgetDetailApi(payload);
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error?.message || "Failed to get moment detail");
    }
  }
);

export const setwidgetpreferenceAction = createAsyncThunk(
  "action/setwidgetpreference",
  async ({ payload, isshowsnackbar = true }: any, { rejectWithValue, dispatch }) => {
    try {
      const response = await setwidgetpreferenceApi(payload);
      if (isshowsnackbar) {
        dispatch(
          showSnackbar({ message: response?.data?.message, type: "success" })
        );
      }

      return response.data;
    } catch (error: any) {
      dispatch(
        showSnackbar({ message: error?.response?.data?.message, type: "error" })
      );
      return rejectWithValue(error?.message || "Failed to get widget");
    }
  }
);

export const sendWidgetInstallEmailAction = createAsyncThunk(
  "send/widgetInstallEmail",
  async (
    payload: { widget_id: string; business_id: string; to: string },
    { rejectWithValue, dispatch }
  ) => {
    try {
      const response = await sendWidgetInstallEmailApi(payload);
      dispatch(
        showSnackbar({
          message:
            response?.data?.message ||
            "Installation instructions email sent successfully!",
          type: "success",
        })
      );
      return response.data;
    } catch (error: any) {
      dispatch(
        showSnackbar({
          message: error?.response?.data?.message || "Failed to send email",
          type: "error",
        })
      );
      return rejectWithValue(error?.message || "Failed to send email");
    }
  }
);
